"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var printDependencies = exports.printDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createPrint: _factoriesAny.createPrint
};